import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 267AF23F-D48A-493E-91BD-E78CD3EFCCBA
 * name pot
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pot.svg
 * tags
 * - Food / Drink 
 * - Holiday 
 */
export const PotIcon = createSvgIcon(<><path d="M19 19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V12H3V10H21V12H19V19Z" /></>, 'PotIcon');
export default PotIcon